{
  "changeChain": {
    "title": "Bir zincir seçin"
  },
  "checkoutBlocked": {
    "notAvailable": "Kullanılamıyor",
    "regionMessage": "Bu hizmet bölgenizde kullanılamıyor.",
    "viewRegions": "Kullanılabilir bölgeleri görüntüle."
  },
  "common": {
    "addressCopied": "Adres kopyalandı",
    "back": "Geri",
    "cancel": "İptal",
    "close": "Kapat",
    "confirm": "Onayla",
    "continue": "Devam et",
    "copied": "Kopyalandı!",
    "copy": "Kopyala",
    "copyAddress": "Adresi kopyala",
    "done": "Tamam",
    "go": "Git",
    "loading": "Yükleniyor…",
    "ok": "Tamam",
    "poweredBy": "destekleyen",
    "tryAgain": "Tekrar dene",
    "startOver": "Yeniden başla"
  },
  "depositAmount": {
    "amountLabel": "Tutar",
    "changeToMaximum": "Maksimuma değiştir",
    "changeToMinimum": "Minimuma değiştir",
    "delete": "Sil",
    "enterAmount": "Bir tutar girin",
    "fee": "{{amount}} ücret",
    "maximumAmount": "Maksimum yatırma {{amount}}",
    "minimumAmount": "Minimum yatırma {{amount}}",
    "title": "Para yatırma",
    "submit": "Yatır",
    "submitWithMethod": "{{method}} ile yatır"
  },
  "feeDetails": {
    "amount": "Tutar",
    "fee": "{{rate}} ücret",
    "summaryAddedToCharge": "{{method}} ile para yatırma işlemlerinde {{rate}} ücret alınır ve bu tutar toplam ödemenize eklenir.",
    "summaryDeductedFromDeposit": "{{method}} ile para yatırma işlemlerinde {{rate}} ücret alınır ve bu tutar alacağınız tutardan düşülür.",
    "title": "Ücret ayrıntıları",
    "totalCost": "Toplam tutar",
    "youllGet": "Alacağınız tutar"
  },
  "fiat": {
    "agreeAndContinue": "Koşulları kabul et ve devam et",
    "amountLabel": "Yatırma tutarı",
    "applePay": "Apple Pay",
    "applePayNotSetUp": "Apple Cüzdan’a bir kart ekleyip tekrar deneyin.",
    "applePayUnsupported": "Bu cihaz Apple Pay ile ödeme yapamıyor.",
    "blocked": "Yatırma işlemleri bölgenizde kullanılamıyor",
    "card": "Kart",
    "contactVerifyBoth": "Lütfen telefon numaranızı ve e-posta adresinizi doğrulayın",
    "contactVerifyEmail": "Lütfen e-posta adresinizi doğrulayın",
    "contactVerifyPhone": "Lütfen telefon numaranızı doğrulayın",
    "countryHeading": "Ülkeniz",
    "countrySearchPlaceholder": "Ara",
    "delete": "Sil",
    "deposit": "Yatır",
    "depositReceived": "{{amount}} tutarında yatırma alındı",
    "depositReceivedFrom": "{{method}} ile",
    "emailPlaceholder": "E-posta adresiniz",
    "failure": "Para yatırma başarısız oldu",
    "fee": "{{amount}} ücret",
    "getNewPrice": "Yeni fiyat al",
    "kycConsentCheck": "Fun'ın kimliğimi doğrulamasına ve sonucu siparişimi tamamlayan ödeme sağlayıcısıyla paylaşmasına izin veriyorum. Ayrıntılar için",
    "kycConsentPrompt": "Devam ederek Fun'ın kimliğinizi doğrulamasına ve sonucu siparişinizi tamamlayan ödeme sağlayıcısıyla paylaşmasına izin vermiş olursunuz. Ayrıntılar için",
    "kycConsentStop": ".",
    "kycDetailAddress": "Lütfen adresinizi girin",
    "kycDetailDob": "Lütfen doğum tarihinizi girin",
    "kycDetailName": "Yatırımınızı güvence altına almak için kimliğiniz hakkında daha fazla bilgiye ihtiyacımız var.",
    "kycDetailNationality": "Uyruğunuz",
    "kycDetailOther": "Kalan bilgileri girin",
    "kycDetailSsn": "Lütfen 9 haneli SSN numaranızı girin",
    "kycFileUnsupported": "Belge yükleme burada henüz kullanılamıyor — bu adımı yakında tamamlayabileceksiniz.",
    "kycFormDetail": "İlk yatırımınızdan önce birkaç bilgi gerekiyor.",
    "kycFormInvalid": "Bu bilgilerin bir kısmı gözden geçirilmeli.",
    "kycPhoneInUse": "Bu telefon numarası başka bir {{provider}} hesabında zaten kullanılıyor. Farklı bir numara girin.",
    "kycTaxIdInUse": "Bu vergi numarası başka bir {{provider}} hesabında zaten kullanılıyor.",
    "kycFormMissing": "Bazı zorunlu bilgiler eksik.",
    "kycFormStale": "Bu adım değişti. Aşağıdaki bilgileri kontrol edin.",
    "kycFormTitle": "Kimliğinizi doğrulayın",
    "kycIntroDetail": "Bu, hesabınızı güvende tutarken para yatırma işlemlerinizi gerçekleştirmemizi sağlar. Yalnızca bir dakika sürer ve kimlik belgesi gerekmez.",
    "kycNoticeCountryCode": "AU gibi iki harfli ülke kodunu kullanın",
    "kycNoticeDateFormat": "YYYY-AA-GG biçimini kullanın",
    "kycNoticeDatePast": "Geçmiş bir tarih girin",
    "kycNoticeInvalid": "Vurgulanan alanları kontrol edin",
    "kycNoticeRequired": "Vurgulanan alanları doldurun",
    "kycNoticeUnderage": "Devam etmek için en az 18 yaşında olmalısınız",
    "kycOnHold": "Doğrulama beklemede",
    "kycOnHoldDetail": "Daha sonra geri gelip tekrar deneyebilirsiniz.",
    "kycOnHoldUntil": "{{date}} tarihinde tekrar deneyebilirsin.",
    "kycOpenLink": "Doğrulamaya devam et",
    "kycOptional": "isteğe bağlı",
    "kycPrivacyPolicy": "Gizlilik Politikamıza",
    "kycProviderGeneric": "ödeme sağlayıcısı",
    "kycProviderGenericId": "doğrulama iş ortağımız",
    "kycProviderTerms": "{{provider}} şartlar ve koşulları",
    "kycProviderTermsPrompt": "Devam ederek kabul etmiş olursunuz:",
    "kycRejected": "Doğrulama başarısız oldu",
    "kycRejectedSupport": "Destek ekibine yazın, konuyu inceleyelim.",
    "kycRequired": "Doğrula ve yatır",
    "kycRequiredCta": "Doğrulama gerekli →",
    "kycRequiredDetail": "Yatırma işlemine devam etmek için doğrulamayı tamamlayın.",
    "kycRequiredTitle": "Kimlik doğrulaması gerekli",
    "kycCompleteDetail": "Para yatırma limitiniz artırıldı.",
    "kycCompleteTitle": "Kimlik doğrulama tamamlandı",
    "kycHardCta": "Seçenekleri gör →",
    "kycHardDetail": "Kimlik doğrulama ile para yatırma limitinizi artıramıyoruz.",
    "kycHardTitle": "Kimliğiniz doğrulanamıyor",
    "kycPendingCta": "Doğrulama bekleniyor →",
    "kycPendingDetail": "Doğrulamanızı en kısa sürede tamamlamak için çalışıyoruz.",
    "kycPendingTitle": "Kimlik doğrulama sürüyor",
    "kycSoftCta": "Doğrulama gerekli →",
    "kycSoftDetail": "Doğrulamanızdaki sorunları düzeltmek için yeniden deneyebilirsiniz.",
    "kycSoftTitle": "Kimlik doğrulama başarısız oldu",
    "kycOptionCloseDetail": "Çık ve bu yatırmaya daha sonra geri dön.",
    "kycOptionCloseTitle": "Yatırmayı kapat",
    "kycOptionMaxDetail": "Doğrulamadan önce {{max}} tutarına kadar.",
    "kycOptionMaxDetailUnknown": "Doğrulamadan önce mevcut limitinize kadar.",
    "kycOptionMaxTitle": "Maksimum tutarı yatır",
    "kycOptionRedoDetail": "Bilgilerinizi ve belgelerinizi kontrol edip yeniden deneyin.",
    "kycOptionRedoTitle": "Kimlik doğrulamayı yeniden yap",
    "kycOptionSupportDetail": "Kimlik doğrulama gereklilikleriyle ilgili sorunlar için bize ulaşın.",
    "kycOptionSupportTitle": "Yardım ve destek",
    "kycOptionsHardTitle": "Kimlik doğrulamasından sonra para yatırma limitinizi artıramıyoruz.",
    "kycOptionsLabel": "Şu anda şunları yapabilirsiniz:",
    "kycOptionsPendingTitle": "Kimlik doğrulamanız hâlâ işleniyor. Para yatırma limitleriniz henüz değişmedi.",
    "kycOptionsSoftTitle": "Kimlik doğrulamanız başarısız oldu. Son denemedeki sorunları düzeltmek için yeniden deneyin.",
    "kycTitle": "Kimlik doğrulama",
    "otpDetailAnyEmail": "Kod e-postanıza gönderildi",
    "otpDetailAnyPhone": "Kod telefonunuza gönderildi",
    "otpDetailEmail": "Kod {{email}} adresine gönderildi",
    "otpDetailPhone": "Kod {{phone}} numarasına gönderildi",
    "otpError": "Bu kod çalışmadı. Kontrol edip tekrar deneyin.",
    "otpExpired": "Bu kodun süresi doldu. Yeni bir kod isteyin.",
    "otpRateLimited": "Çok fazla kod istendi. Tekrar denemeden önce lütfen bekleyin.",
    "otpRateLimitedTitle": "Başka bir kod istemeden önce lütfen bekleyin",
    "otpPlaceholder": "6 haneli kod",
    "otpResend": "Yeniden gönder",
    "otpResendPrompt": "Kod gelmedi mi?",
    "otpTitle": "Kodu girin",
    "payButton": "Apple Pay ile yatır",
    "paySheetPay": "Öde",
    "paySheetTitle": "Apple Pay ile onayla",
    "paySheetTotal": "Toplam {{amount}}",
    "phoneCountryLabel": "Ülke kodu",
    "phoneCountrySearch": "Ülke ara",
    "phonePlaceholder": "Telefon numaranız",
    "processing": "Yatırma işleminiz gerçekleştiriliyor…",
    "pendingOrderTitle": "Tamamlanmamış bir yatırma işleminiz var",
    "pendingOrderDetail": "{{amount}} tutarındaki yatırma işleminize devam edin veya yeni bir tutarla devam etmek için iptal edin.",
    "resumeDeposit": "Yatırma işlemine devam et",
    "cancelDeposit": "Yatırma işlemini iptal et",
    "quoteExpired": "Bu fiyatın süresi doldu",
    "quoteFailed": "Fiyat alınamadı",
    "redirectDetail": "Geri döndüğünüzde bu ekranı güncelleyeceğiz.",
    "redirectReopen": "Tarayıcıyı yeniden aç",
    "redirectTitle": "Ödemenizi tarayıcıda tamamlayın",
    "refunded": "Yatırılan tutar geri ödendi",
    "refusalDetails": "Girdiğiniz bilgileri kontrol edip tekrar deneyin.",
    "refusalDetailsTitle": "Bu bilgilerden bazıları gözden geçirilmeli",
    "refusalLimits": "Daha düşük bir tutar veya başka bir ödeme yöntemi deneyin.",
    "refusalLimitsTitle": "Bu ödeme yöntemi bu tutarı kabul etmiyor",
    "refusalUnavailable": "Sorun bizden kaynaklı - biraz sonra tekrar deneyin veya daha düşük bir tutar deneyin.",
    "refusalUnavailableTitle": "Şu anda kullanılabilir bir ödeme seçeneği yok",
    "requote": "Yeni teklif al",
    "reviewTitle": "Yatırma işleminizi onaylayın",
    "orderConfirmingTitle": "Ödemeniz onaylanıyor",
    "orderConfirmingDetail": "Ödemeniz gerçekleşti. Yatırma işleminizi kaydediyoruz, bu biraz sürebilir.",
    "submitFailed": "Gönderilemedi",
    "paymentFailed": "Lütfen tekrar deneyin",
    "submitting": "Gönderiliyor",
    "stripeAuthDetail": "Link ile güvenli bir şekilde devam etmek için {{email}} adresini kullanacağız.",
    "stripeAuthorizing": "Stripe'da devam et",
    "stripeAuthorizingDetail": "Stripe penceresinde Link doğrulamasını ve onayını tamamlayın.",
    "stripeAuthTitle": "Stripe ile devam et",
    "stripeAuthFailed": "Stripe oturumunuz başlatılamadı. Tekrar deneyin.",
    "stripeKycInfoFailed": "Bilgileriniz Stripe'a kaydedilemedi. Bilgilerinizi kontrol edip tekrar deneyin.",
    "stripeRegistrationFailed": "Link hesabınız oluşturulamadı. Bilgilerinizi kontrol edip tekrar deneyin.",
    "success": "Yatırma işlemi tamamlandı",
    "successDetail": "Bakiyeniz bir süre sonra güncellenecek.",
    "termsNotice": "Devam ederek sağlayıcının\n<terms>Koşullar</terms> belgesini kabul etmiş olursunuz.",
    "unsupported": "Bu adım henüz kullanılamıyor",
    "verifying": "Kimliğiniz doğrulanıyor…",
    "verifyingDetail": "Bu genellikle bir dakikadan az sürer.",
    "verifyingSlow": "Doğrulama sürüyor",
    "verifyingSlowDetail": "Bunu kapatıp kısa süre sonra tekrar bakabilirsin.",
    "coinbaseTermsNotice": "Devam ederek Coinbase’in\n<terms>Koşullar</terms>, <agreement>Kullanıcı Sözleşmesi</agreement> ve <privacy>Gizlilik Politikası</privacy> belgelerini kabul etmiş olursunuz.",
    "contactInvalidEmail": "Lütfen geçerli bir e-posta adresi girin",
    "kycIntroTitle": "Kimliğinizi doğrulayalım",
    "kycAdditionalTitle": "Biraz daha bilgiye ihtiyacımız var",
    "kycAdditionalDetail": "Daha yüksek para yatırma limitlerini açmak için ek doğrulama gereklidir. Doğrulama tamamlanır tamamlanmaz daha yüksek limitler kullanılabilir olacaktır.",
    "kycFindOutMore": "Daha fazla bilgi",
    "kycR2Consent": "Devam ederek Fun tarafından kimliğinizin doğrulanmasına ve sonuçların belirli ödeme sağlayıcılarıyla paylaşılmasına izin verirsiniz.",
    "kycAgreeContinue": "Kabul et ve devam et",
    "kycSsnLastFour": "SSN’nizin son 4\nhanesini girin",
    "kycSsnProtection": "ABD yasaları gereği kimlik doğrulaması için SSN toplamak zorundayız. Bilgileriniz banka düzeyinde şifrelemeyle korunur.",
    "kycDetailCountry": "Ülkeniz",
    "kycCountry": "Ülke",
    "kycDetailOccupation": "Mesleğiniz",
    "kycDetailPurpose": "Lütfen işlem amacınızı belirtin",
    "kycOccupation": "Meslek",
    "kycPurpose": "İşlem amacı",
    "kycDetailPhone": "Cep telefonu numaranız",
    "kycDetailEmployment": "Çalışma durumunuz",
    "kycDetailSourceOfWealth": "Servet kaynağınız",
    "kycDetailIncome": "Brüt yıllık geliriniz",
    "kycDetailActivity": "Aylık işlem hacminiz",
    "kycIncomeCaption": "Vergi öncesi, yerel para biriminizde",
    "kycReviewTitle": "Teşekkürler! Bilgileriniz alındı ve inceleniyor.",
    "kycHoldTitle": "Teşekkürler! Bilgileriniz alındı. İncelemeyi tamamlamak için biraz daha zamana ihtiyacımız var.",
    "kycRestrictedTitle": "Hesabınız kısıtlandı.",
    "regionUnsupportedTitle": "Bölgeniz desteklenmiyor.",
    "kycAnyQuestions": "Sorunuz mu var?",
    "kycGetHelpSupport": "Yardım ve destek alın",
    "otpVerified": "Kod doğrulandı",
    "authConnectFailedTitle": "{{provider}} hesabınız bağlanamadı",
    "authConnectFailedDetail": "Baştan oturum açmak için yeniden başlayın.",
    "kycUnavailableTitle": "Doğrulama geçici olarak kullanılamıyor.",
    "kycUnavailableNetwork": "Birazdan tekrar deneyin veya daha sonra geri gelin.",
    "kycUnavailableProviderTitle": "Doğrulamanızı tamamlayamadık.",
    "kycUnavailableProvider": "Bizim tarafımızda bir sorun oluştu. Destek ile iletişime geçin, buradan biz devralalım.",
    "contactSupport": "Destek ile iletişime geçin",
    "kycDocumentTitle": "Kimliğiniz doğrulanıyor",
    "kycDocumentDetail": "Doğrulamanızı tamamlamak için kimliğinizi kontrol etmemiz gerekiyor. Kimlik doğrulama {{provider}} tarafından sağlanır.",
    "kycDocumentContinue": "{{provider}} ile kimliği doğrula",
    "applePayUnavailableTitle": "Apple Pay geçici olarak kullanılamıyor.",
    "kycLimitNotice": "Günlük limite ulaşıldı: daha yüksek limitleri hemen açmak için kimliğinizi doğrulayın.",
    "contactEmailRejected": "Bu e-posta adresi doğrulanamıyor. Lütfen başka bir adres seçin.",
    "contactReverifyPhone": "Lütfen telefon numaranızı tekrar doğrulayın.",
    "coinbaseCardSoftDeclined": "Bankanız bu ödemeyi reddetti. Apple Pay'de başka bir kart deneyin veya bankanıza danışın.",
    "coinbaseCardHardDeclined": "Bankanız bu kartı reddetti. Apple Pay'de farklı bir kart kullanın.",
    "coinbaseCardRiskDeclined": "Bu ödeme onaylanamadı. Apple Pay'de farklı bir kart deneyin.",
    "coinbaseInvalidCard": "Apple Pay'deki kartı ve fatura adresini kontrol edip tekrar deneyin.",
    "coinbaseInsufficientBalance": "Bu kartta bu yatırma için yeterli bakiye yok.",
    "coinbasePrepaidCard": "Ön ödemeli kartlar kabul edilmiyor. Apple Pay'de bir banka kartı kullanın.",
    "coinbaseRegionUnsupported": "Bulunduğunuz yerde kartla yatırma kullanılamıyor.",
    "coinbasePermissionDenied": "Bu ödeme yöntemi hesabınızda kullanılamıyor.",
    "coinbaseWeeklyLimit": "Bu, haftalık kart yatırma limitinizi aşar. Daha küçük bir tutar deneyin.",
    "coinbaseLifetimeCount": "Coinbase hesabı olmadan kullanabileceğiniz tüm kart yatırma haklarını kullandınız.",
    "coinbaseDailyCount": "Bugünkü kart yatırma limitine ulaştınız. Yarın tekrar deneyin.",
    "coinbaseBillingZip": "Fatura posta kodu kartınızla eşleşmedi. Kontrol edip tekrar deneyin.",
    "coinbaseBillingAddress": "Fatura adresi eksik. Kontrol edip tekrar deneyin.",
    "coinbaseBillingName": "Kart sahibinin adı kabul edilmedi. Kontrol edip tekrar deneyin.",
    "coinbaseSessionExpired": "Bu ödeme oturumu sona erdi. Yatırma işlemini yeniden başlatın.",
    "coinbaseNetworkUnsupported": "Bu ağ bulunduğunuz yerde kullanılamıyor.",
    "coinbaseAssetUnsupported": "Bu token bulunduğunuz yerde kullanılamıyor.",
    "coinbaseProviderError": "Coinbase bunu tamamlayamadı. Birazdan tekrar deneyin.",
    "coinbaseBuyFailed": "Satın alma tamamlanamadı. Kartınızdan çekim yapılmadı.",
    "coinbaseSendFailed": "Yatırma teslim edilemedi. Kartınıza iade yapılacak.",
    "coinbaseAvsFailed": "Fatura adresiniz doğrulanamadı. Bankanızla kontrol edip tekrar deneyin.",
    "cancelled": "Yatırma iptal edildi",
    "sessionExpired": "Oturumunuzun süresi doldu. Yatırmaya devam etmek için tekrar giriş yapın.",
    "accountIneligibleTitle": "Bu hesap için yatırma kullanılamıyor",
    "accountIneligibleDetail": "Bunun bir hata olduğunu düşünüyorsanız destekle iletişime geçin."
  },
  "fops": {
    "bankTransferSubtitle": "{{limit}} limit · 1-2 gün",
    "bankTransferTime": "1-2 gün",
    "instant": "Anında",
    "limit": "{{limit}} limit"
  },
  "networks": {
    "chainFallback": "Zincir {{chainId}}",
    "minimum": "En az ${{min}}"
  },
  "qrCode": {
    "title": "QR Kodu"
  },
  "selectChain": {
    "subtitle": "Yatırma yapacağınız ağı seçin",
    "title": "Kripto yatır"
  },
  "selectMethod": {
    "crypto": "Kripto",
    "depositTo": "Şuraya yatır",
    "errorMessage": "Veriler yüklenirken bir sorun oluştu.\nİnternet bağlantınızı kontrol edip tekrar deneyin.",
    "errorTitle": "Bir şeyler ters gitti",
    "loadingMethods": "Ödeme yöntemleri yükleniyor",
    "noLimit": "Limitsiz",
    "payWith": "Şununla öde",
    "title": "Para ekle"
  },
  "selectReceiveToken": {
    "availableTokens": "Kullanılabilir tokenlar",
    "moreTokens_one": "+{{count}} token",
    "moreTokens_other": "+{{count}} token",
    "searchTokens": "Token ara",
    "selectChain": "Zincir seçin",
    "selectToken": "Token seçin",
    "title": "Alınacak token ve zincir"
  },
  "transferCrypto": {
    "changeChain": "Zinciri değiştir",
    "depositAddressLabel": "Yatırma adresiniz",
    "generating": "Oluşturuluyor…",
    "selectedChain": "Seçili zincir",
    "share": "Paylaş",
    "shareAddress": "Adresi paylaş",
    "showQrCode": "QR kodunu göster",
    "title": "Kripto Transferi"
  },
  "withdraw": {
    "belowMinimumMessage": "Bakiyeniz nakit çekim için gereken minimumun altında.",
    "belowMinimumTitle": "Bakiye çok düşük",
    "cashMethodsError": "Nakit çekim yöntemleri yüklenemedi. Kripto ile çekim yapmaya devam edebilirsiniz.",
    "noCashMethods": "Banka ve kart ile çekim bölgenizde kullanılamıyor. Kripto ile çekim yapmaya devam edebilirsiniz.",
    "title": "Para çek",
    "unavailableMessage": "Nakit çekimler şu anda bölgenizde kullanılamıyor.",
    "unavailableTitle": "Çekimler kullanılamıyor"
  },
  "withdrawAddress": {
    "breakdown": "Yaklaşık {{amount}} alacaksınız. Ağ koşullarına göre biraz değişebilir. Bu işlem {{minimum}} altındaki bir fiyattan gerçekleşmez. İşleminiz birkaç saniye içinde tamamlanmalı.",
    "breakdownTitle": "İşlem dökümü",
    "clear": "Temizle",
    "detected": "Cüzdan algılandı",
    "notFound": "Cüzdan bulunamadı",
    "paste": "Yapıştır",
    "requested": "Para Çekme Talep Edildi",
    "title": "{{amount}} çek",
    "useConnected": "Bağlı cüzdanı kullan",
    "withdrawNow": "Şimdi çek",
    "withdrawing": "Çekiliyor",
    "withdrew": "Çekildi",
    "youllReceive": "Alacağınız tutar"
  },
  "withdrawAmount": {
    "amountLabel": "Tutar",
    "delete": "Sil",
    "swapDenomination": "Dolar ve token arasında geçiş yap",
    "useMax": "Tümünü kullan"
  },
  "withdrawCrypto": {
    "aboveBalance": "Yetersiz bakiye",
    "addressPlaceholder": "Cüzdan adresi",
    "available": "{{amount}} {{symbol}} kullanılabilir",
    "belowFee": "Tutar, {{amount}} ücretten fazla olmalıdır",
    "belowMinimum": "Minimum Tutar: {{amount}}",
    "ctaInvalidForChain": "Adres bu ağ için geçerli değil",
    "ctaMaxExceeded": "Maksimum tutar aşıldı",
    "ctaRecipientSameAsSource": "Farklı bir adres seçin",
    "ctaSelectDestination": "Bir hedef seçin",
    "errorGeneric": "Para çekme başarısız oldu. Lütfen tekrar deneyin.",
    "errorInsufficientGas": "Bu işlem için yeterli gaz yok.",
    "errorSwitchChain": "Ağ değiştirilemiyor. Lütfen cüzdanınızın ağı desteklediğinden emin olun.",
    "failedMessage": "{{amount}} alıcıya ulaşmadı. Fonlar geri gelmezse destek ekibiyle iletişime geçin.",
    "failedTitle": "Para çekme tamamlanmadı",
    "max": "Maks.",
    "methodSubtitle": "Limit yok",
    "methodTitle": "Kripto adresi",
    "quoteFailed": "Takas teklifi alınırken hata oluştu. Lütfen tekrar deneyin.",
    "receiveAs": "Şu şekilde al",
    "refundedMessage": "{{amount}} cüzdanınıza geri gönderildi.",
    "riskyAddress": "Bu cüzdan adresi kısıtlamalar nedeniyle kullanılamaz.",
    "selectSource": "Kaynak seç",
    "sendFrom": "Şuradan çek",
    "successPendingMessage": "{{amount}} zincir üzerinde işleniyor. Bu ekranı kapatabilirsiniz.",
    "successPendingTitle": "Çekim gönderildi",
    "title": "Kripto çek",
    "unsupportedRecipient": "Desteklenmeyen alıcı adresi"
  },
  "withdrawLighter": {
    "delayHours": "{{hours}} sa",
    "delayHoursMinutes": "{{hours}} sa {{minutes}} dk",
    "delayMinutes": "{{minutes}} dk",
    "delaySecond": "1 saniye",
    "delaySeconds": "{{seconds}} saniye",
    "fastDisclaimer": "Yalnızca USDC Perps · Birden fazla zincir · Anında",
    "fastDisclaimerUnified": "Yalnızca USDC · Birden fazla zincir · Anında",
    "methodFast": "Hızlı",
    "methodSecure": "Yerel Köprü",
    "secureDisclaimer": "Tüm tokenlar · Yalnızca Ethereum zinciri · {{delay}}",
    "secureFallbackDelay": "60+ dakika"
  },
  "withdrawNado": {
    "errorAmountTooLow": "Tutar, Nado para çekme ücretini karşılamak için çok düşük.",
    "errorBalanceChanged": "Çekilebilir bakiyeniz değişti. Maks'a dokunup tekrar deneyin.",
    "errorInvalidNonce": "Bu para çekme talebinin süresi doldu. Lütfen tekrar deneyin.",
    "errorNetwork": "Şu anda Nado'ya ulaşılamıyor. Lütfen tekrar deneyin.",
    "errorNoPriorDeposit": "Para çekmeden önce Nado'ya yatırma yapın.",
    "errorRateLimited": "Çok fazla istek. Lütfen biraz bekleyip tekrar deneyin.",
    "errorSignerMismatch": "Para çekmek için bu Nado hesabının sahibi olan cüzdana geri geçin.",
    "errorUnconfirmed": "Para çekme işleminizi doğrulayamadık. Tekrar denemeden önce Nado bakiyenizi kontrol edin.",
    "errorWithdrawRisk": "Nado'nun 24 saatlik para çekme limitine ulaşıldı. Lütfen daha sonra tekrar deneyin."
  },
  "paymentMethods": {
    "applePay": "Apple Pay",
    "card": "Kart"
  },
  "lockedTransfer": {
    "amountInfoTitle": "Gönderilecek tutar",
    "amountInfoDescription": "{{amount}} yatırmak için göndermeniz gereken tutardır. Bu tutarın üzerinde gönderilen fonlar yatırılmaz ve geri almak için destek ekibine başvurmanız gerekir.",
    "amountLoading": "Hesaplanıyor…",
    "amountUnavailable": "Tutar alınamadı",
    "title": "Kripto yatır",
    "send": "Gönder",
    "amount": "Tutar",
    "address": "Tek kullanımlık yatırma adresi",
    "copyAmount": "Tutarı kopyala",
    "amountCopied": "Tutar kopyalandı",
    "showFullAddress": "Tam adresi göster",
    "tokenOnChain": "{{chain}} üzerinde {{token}}"
  },
  "selectAsset": {
    "emptyChains": "Desteklenen ağ bulunmuyor",
    "combinedTitle": "Göndereceğiniz token ve ağ",
    "title": "Varlık seçin",
    "empty": "Desteklenen varlık bulunamadı"
  }
}
